export default __webpack_public_path__ + "static/product_003-eb5032005f0e85b65fd52deaaa1307f5.jpg";